import { ENV_ENV } from "../../../../../config/envVars";

export const VEHICLE_TYPE = {
  NEW: "new",
  INVENTORY: "inventory",
  USED: "used",
};

// TODO: For transition purposes. Remove this once all new applications have model version code.
const MODEL_Y_IN_CAMPAIGN = [
  "Model Y Standard Range Rear-Wheel Drive Campaign", // mty68 2,49%
  "Model Y Rear-Wheel Drive (RWD) Campaign", // mty85 2,49%
];

const MODEL_Y_VERSION_CODE_IN_CAMPAIGN = ["$MTY68", "$MTY85"];

export const getPricingIdByModelVersionCodeAndAgentId = ({
  modelVersion,
  modelVersionCode,
  agentId,
  registrationDate,
}) => {
  const vehicleType = getVehicleTypeByAgentId(agentId);

  if (!vehicleType) return;

  const isNewModelYInCampaign = modelVersionCode
    ? MODEL_Y_VERSION_CODE_IN_CAMPAIGN.includes(modelVersionCode)
    : MODEL_Y_IN_CAMPAIGN.includes(modelVersion);

  if (ENV_ENV === "stg") {
    switch (vehicleType) {
      case VEHICLE_TYPE.USED:
        return;
      case VEHICLE_TYPE.INVENTORY:
        if (isNewModelYInCampaign) {
          if (registrationDate) {
            return "1eaa947e-ff71-424b-9240-17e830de5322"; //'CAIXABANK - Seminuevo CAMPAÑA 2T26 INVENTORY 2,99%  (S1W v2) (24-84)'
          }
          return "49103469-057e-48b6-aa7f-efe653e7bea0"; //'CAIXABANK - Nuevo CAMPAÑA 2T26 INVENTORY 2,99%  (S1W v2) (24-84)'
        } else {
          if (registrationDate) {
            return "84eb8bb7-b800-48dc-83f9-29ceee36d0e7";
          }
          return "9aa4b5f8-1d8a-4df0-a5de-78e4088ae321"; // R6V v3
        }
      case VEHICLE_TYPE.NEW:
        if (isNewModelYInCampaign) {
          if (registrationDate) {
            return "cf4bdd29-05fb-48b9-9120-64a7ba7db29d"; //'CAIXABANK - Seminuevo CAMPAÑA 2T26 2,99%  (S1V v2) (24-84)'
          }
          return "80cacfb8-5ddd-40d5-9deb-782a09ff7484"; //'CAIXABANK - Nuevo CAMPAÑA 2T26 2,99%  (S1V v2) (24-84)'
        } else {
          return "5ae3c41d-e33e-46e0-b9ff-8afae27f9712"; // R6T v3
        }
    }
  }

  if (ENV_ENV === "prod") {
    switch (vehicleType) {
      case VEHICLE_TYPE.USED:
        return;
      case VEHICLE_TYPE.INVENTORY:
        if (isNewModelYInCampaign) {
          if (registrationDate) {
            return "d185f6a8-f111-4e4e-a4cf-dfe9e7b85e2e"; // CAIXABANK - Seminuevo CAMPAÑA 4T26 INVENTORY (SGR v3) (24-84)
          }
          return "72338d01-ab30-4d87-ac49-8a6f5633ceae"; // CAIXABANK - Nuevo CAMPAÑA 4T26 INVENTORY (SGR v3) (24-84)
        } else {
          if (registrationDate) {
            return "a705f409-eda4-4a40-b8bc-8325ffe07dca"; // NUU v7 seminuevo
          }
          return "4e4c18d6-e5c0-44c2-bce4-a5d26acf7d3c"; // NUU v7 nuevo
        }
      case VEHICLE_TYPE.NEW:
        if (isNewModelYInCampaign) {
          if (registrationDate) {
            return "57cc84e7-4460-4a1b-9afd-85c00ff1bd88"; // CAIXABANK - Seminuevo CAMPAÑA 4T26 VN (SGQ v3) (24-84)
          }
          return "1c46d481-4ef5-477d-9cff-e8416f64e6c4"; // CAIXABANK - Nuevo CAMPAÑA 4T26 VN (SGQ v3) (24-84)
        } else {
          return "6ab09425-3edb-4db3-80ac-05e21e4942a6"; // 4YA v11 nuevo
        }
    }
  }

  return;
};

const getVehicleTypeByAgentId = (agentId) => {
  if (ENV_ENV === "dev" || ENV_ENV === "local") {
    return undefined;
  }
  return VEHICLE_TYPE_BY_AGENT_ID[ENV_ENV][agentId];
};

const VEHICLE_TYPE_BY_AGENT_ID = {
  ["stg"]: {
    ["99deb750-086c-4e4c-973f-dd8d14e194e3"]: VEHICLE_TYPE.NEW, // tesla.web@nemuru.com
    ["e39dc600-fedd-4167-a049-10362b081590"]: VEHICLE_TYPE.USED, // tesla.web.vo@nemuru.com
    ["d12a80f1-2a4d-4942-a620-5e711e12253d"]: VEHICLE_TYPE.INVENTORY, // tesla.web.inventory@nemuru.com
  },
  ["prod"]: {
    ["cf810a79-a5e0-48c7-85ef-855bec61770a"]: VEHICLE_TYPE.NEW, // tesla.web@nemuru.com
    ["50f193e9-5fae-4433-95d2-0648aea6f3bc"]: VEHICLE_TYPE.USED, // tesla.web.vo@nemuru.com
    ["a6e63771-6f67-471f-8b65-f806e8a443bb"]: VEHICLE_TYPE.INVENTORY, // tesla.web.inventory@nemuru.com
  },
};
